import * as moment from "moment";

import { Model } from "./model";
import { Course } from "./course";
import { Term } from "./term";
import { Event } from "./event";
import { Contact } from "./contact";
import { Ticket } from "./ticket";

export class TicketAllocation extends Model {

  constructor(
    public id?: number,
    public termId?: number,
    public courseId?: number,
    public eventId?: number,
    public contactId?: number,
    public title: string = null,
    public price: number = null,
    public whenDisplay: string = null,
    public location: string = null,
    public locationUrl: string = null,
    public saleStartDateTime: Date = null,
    public saleEndDateTime: Date = null,
    public startDateTime: Date = null,
    public endDateTime: Date = null,
    public quantity: number = null,
    public recurringDays: number = null,
    public soldCount: number = 0,
    public remainingCount: number = 0,

    public course: Course = null,
    public term: Term = null,
    public event: Event = null,
    public contact: Contact = null,
    public tickets: Ticket[] = [],

    public uiState: any = {},

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super(); }

  static clone(obj: any) {
    const e = new this();

    if (obj.id) { e.id = obj.id }
    if (obj.termId) { e.termId = obj.termId }
    if (obj.courseId) { e.courseId = obj.courseId }
    if (obj.eventId) { e.eventId = obj.eventId }
    if (obj.contactId) { e.contactId = obj.contactId }
    if (obj.title) { e.title = obj.title }
    if (obj.price) { e.price = parseFloat(obj.price) }
    if (obj.whenDisplay) { e.whenDisplay = obj.whenDisplay }
    if (obj.location) { e.location = obj.location }
    if (obj.locationUrl) { e.locationUrl = obj.locationUrl }
    if (obj.startDateTime) { e.startDateTime = new Date(obj.startDateTime) }
    if (obj.endDateTime) { e.endDateTime = new Date(obj.endDateTime) }
    if (obj.saleStartDateTime) { e.saleStartDateTime = new Date(obj.saleStartDateTime) }
    if (obj.saleEndDateTime) { e.saleEndDateTime = new Date(obj.saleEndDateTime) }
    if (obj.quantity) { e.quantity = obj.quantity }
    if (obj.recurringDays) { e.recurringDays = obj.recurringDays }
    if (obj.remainingCount) { e.remainingCount = obj.remainingCount }
    if (obj.soldCount) { e.soldCount = parseInt(obj.soldCount) }

    if (obj.uiState) { e.uiState = obj.uiState }

    if (obj.course) { e.course = Course.clone(obj.course) }
    if (obj.term) { e.term = Term.clone(obj.term) }
    if (obj.event) { e.event = Event.clone(obj.event) }
    if (obj.contact) { e.contact = Contact.clone(obj.contact) }

    if (obj.tickets && obj.tickets.length > 0) {
      e.tickets = obj.tickets.map((t: any) => Ticket.clone(t)) }

    if (obj.createdAt) { e.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { e.updatedAt = new Date(obj.updatedAt) }

    return e;
  }

  available() {
    return !this.soldOut() && !this.unavailable()
  }

  expired() {
    return moment().isAfter(this.saleEndDateTime)
  }

  unavailable() {
    return moment().isBefore(this.saleStartDateTime) || this.expired()
  }

  soldOut() {
    return this.remainingCount <= 0
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/ticket-allocation.ts